import { CountryCodesConst } from '@axiom/const';
import type { Opportunity, Position } from '@axiom/validation';
import { PositionUtil } from '@axiom/ui';

const { CountryCodesAbbreviations } = CountryCodesConst;

export const LocationUtil = {
  displayFormattedJobLocation: (
    opportunity: Partial<
      Pick<Opportunity, 'locationCityStateCountry' | 'locationName'>
    >,
    position: Partial<Pick<Position, 'worksite'>> | null | undefined
  ) => {
    const worksite = PositionUtil.getWorksite(position);
    const location =
      opportunity.locationCityStateCountry || opportunity.locationName;

    if (worksite && location) {
      return `${worksite} - ${location}`;
    } else if (worksite) {
      return worksite;
    } else if (location) {
      return location;
    }

    return '--';
  },
  qualifyCountryCode: (opportunityCountryCode: string | null) => {
    switch (opportunityCountryCode) {
      case CountryCodesAbbreviations.GB: {
        return CountryCodesAbbreviations.UK;
      }
      default: {
        return opportunityCountryCode;
      }
    }
  },
};
